import { render, staticRenderFns } from "./BotManageInsights.vue?vue&type=template&id=e6bd344c&"
import script from "./BotManageInsights.vue?vue&type=script&lang=js&"
export * from "./BotManageInsights.vue?vue&type=script&lang=js&"
import style0 from "./BotManageInsights.vue?vue&type=style&index=0&id=e6bd344c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports